import axios from 'axios'

const AttachmentService = {

  async uploadAttachments (params, progressCallback = '') {
    return axios.post(
      'shared/attachments/payment-request/upload',
      params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: progressEvent => {
          const { loaded, total } = progressEvent
          const progress = Math.round((loaded * 100) / total).toFixed(2)
          if (typeof progressCallback === 'function') {
            progressCallback(progress, loaded, total)
          }
        }
      }
    )
  },

  async retrieveBranding (name = '') {
    // file, file_path, file_list
    return axios.get(`shared/attachments/payment-request/retrieve-branding?file_name=${name}`, {
      responseType: 'blob'
    }) // responseType: 'blob'
  },

  async retrieveAttachments (path = '', name = '', storage = 'attachment') {
    // file, file_path, file_list
    return axios.get(`shared/attachments/payment-request/retrieve-${storage}?attachment_path=${path}&file_name=${name}`, {
      responseType: 'blob'
    }) // responseType: 'blob'
  },

  async removeAttachments (params) {
    // file, file_path, file_list
    return axios.delete('shared/attachments/payment-request/remove', {
      data: params
    })
  },

  async removeAllAttachments (params) {
    return axios.delete('shared/attachments/payment-request/remove-all', {
      data: params
    })
  }

}

export default AttachmentService
